module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av265-bcc1a9d36f74688fb398b9971288e1b6.jpg";